/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import EditIcon from '@material-ui/icons/Edit';
import SearchBar from "material-ui-search-bar";
import { ProductController } from "controllers";
import styles from "./ProductSearchContainer.module.scss";

import SelectProductField from "./SelectProductField";

import { useSelector } from 'react-redux';
import { selectCountry } from '../../../hyc-store/reducers/countries/countriesReducer';
import { IconButton } from "@material-ui/core";
import { deleteProductById } from "controllers/Product";


const MINIMUM_SEARCH_LENGTH = 3;

let allProduct = [];

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (cmp.length === 0) {
        return array
    } else {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }
}

function getSorting(order, orderBy) {
    if (orderBy.length > 0) {
        return order === "desc"
            ? (a, b) => desc(a, b, orderBy)
            : (a, b) => -desc(a, b, orderBy);
    } else {
        return orderBy;
    }
}

const headCells = [
    { id: "barcode", numeric: true, disablePadding: false, label: "Barcode" },
    { id: "Id", disablePadding: false, label: "Id" },
    { id: "name", numeric: true, disablePadding: false, label: "Name" },
    { id: "size", numeric: true, disablePadding: false, label: "Size" },
    { id: "color", numeric: true, disablePadding: false, label: "Color" },
    { id: "brand", numeric: true, disablePadding: false, label: "Brand" },
    { id: "status", numeric: true, disablePadding: false, label: "Status" },
    {
        id: "category",
        numeric: true,
        disablePadding: false,
        label: "Categories"
    },
    { id: "cycles", numeric: true, disablePadding: false, label: "Cycles" },
    { id: "supplier", numeric: true, disablePadding: false, label: "Supplier" },
    { id: "location", numeric: true, disablePadding: false, label: "Location" },
    { id: "gender", numeric: true, disablePadding: false, label: "Gender" },
    { id: "WashWith", numeric: true, disablePadding: false, label: "Wash With" },
    { id: "buyingprice", numeric: true, disablePadding: false, label: "Buying Price" },
    { id: "targetsalesprice", numeric: true, disablePadding: false, label: "Target Sale Price" },
    { id: "finalsalesprice", numeric: true, disablePadding: false, label: "Final Sale Price" },
    { id: "profit", numeric: true, disablePadding: false, label: "Profit" },
    { id: "soldstatus", numeric: true, disablePadding: false, label: "Sold Status" },
    { id: "platformsold", numeric: true, disablePadding: false, label: "Platform Sold" },
    { id: "yearofproduction", numeric: true, disablePadding: false, label: "Year of Production" },
    { id: "download", numeric: true, disablePadding: false, label: "" }
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={"left"}
                        style={{ fontWeight: "bold" }}
                        padding={headCell.disablePadding ? "none" : "default"}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired
};

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark
            },
    title: {
        flex: "1 1 100%"
    },
    button: {
        textTransform: "none",
        fontWeight: "bold"
    },
    selectField: {
        height: 30
    }
}));

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%",
        flex: 1,
        alignItems: "center"
    },
    paper: {
        width: "100%",
        maxWidth: "95%",
        minHeight: 700,
        margin: "auto"
    },
    table: {
        minWidth: 750
    },
    tableWrapper: {
        overflowX: "auto"
    },
    visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1
    },
    button: {
        '&:hover': {
          backgroundColor: 'transparent', // Disable hover effect
        },
      },
}));

export default function ProductSearchContainer() {
    const classes = useStyles();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("id");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [rows, setRows] = React.useState([]);
    const [key, setKey] = React.useState("");
    const [isDeleting, setIsDeleting] = React.useState(false);

    const [loading, setLoading] = React.useState(true);
    const [dataPull, setDataPull] = React.useState(false);
    const [nextButtonDisable, setNextButtonDisable] = React.useState(false);
    const [productFilterField, setProductFilterField] = React.useState("barcode");

    const country = useSelector(selectCountry);

    const getRows = async (increase, loadLength) => {
        const limit = loadLength || rowsPerPage;
        let barcodes = await ProductController.getOnePageBarcodes(increase, limit, country);

        if (barcodes.length < (loadLength || rowsPerPage)) {
            setDataPull(true);
            setNextButtonDisable(true);
        }

        allProduct = [...allProduct, ...barcodes];
        allProduct.filter(item => {
            if (["at_customer", "kept", "missing"].includes(item.status)) {
                item.status = "At Customer";
            }

            if (["missing"].includes(item.status)) {
                item.status = "Missing";
            }

            if (item.status === "available") {
                item.status = "Available";
            }

            if (item.status === "wash") {
                item.status = "To Wash";
            }
            return item;
        });
        setRows(allProduct);
        setLoading(false);
    };

    const getRowsBySearch = async (search) => {
        const filterFunction = productFilterField === 'color'
            ? await ProductController.getProductByFieldQueryIncludes(productFilterField, search, 25, country) : await ProductController.getProductByFieldQuery(productFilterField, search, 25, country);
        const barcodes = filterFunction

        setPage(0);
        if (barcodes.length <= rowsPerPage) {
            setNextButtonDisable(true);
        }
        barcodes.filter(item => {
            if (["at_customer", "kept", "missing"].includes(item.status)) {
                item.status = "At Customer";
            }

            if (item.status === "available") {
                item.status = "Available";
            }

            if (item.status === "wash") {
                item.status = "To Wash";
            }
            return item;
        });
        setRows(barcodes);
        setLoading(false);
    };

    useEffect(() => {
        getRows(null, null);
        allProduct = [];
    }, []);

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.barcode);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, barcode) => {
        const selectedIndex = selected.indexOf(barcode);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, barcode);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = async (event, newPage) => {
        if (rows.length <= newPage * rowsPerPage) {
            setLoading(true);
            await getRows(true, null);
        } else if (rows.length > newPage * rowsPerPage &&
            rows.length < (newPage + 1) * rowsPerPage) {
            setNextButtonDisable(true);
        } else {
            setNextButtonDisable(false);
        }
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        if (rows.length > event.target.value) {
            setNextButtonDisable(false);
        }
        if (!dataPull && rows.length < event.target.value) {
            setLoading(true);
            getRows(true, parseInt(event.target.value, 10) - rows.length);
        }
        if (dataPull && rows.length <= event.target.value) {
            setNextButtonDisable(true);
        }
    };

    const emptyRows =
        rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const handleChange = async e => {
        if ((e.length >= MINIMUM_SEARCH_LENGTH) && (e.charAt(e.length - 1) !== ' ')) {
            setLoading(true);
            getRowsBySearch(e);
        }
        if (e.length === 0) {
            setLoading(true);
            setNextButtonDisable(false);
            getRows(null, null);
            allProduct = [];
        }
        await setKey(e);
    };
    const HandleDelete = (id) => {
        deleteProductById(id,setRows,isDeleting, setIsDeleting)
        }
    const toolbarClasses = useToolbarStyles();

    return (
        <div className={classes.root}>
            {loading && (
                <div className={styles.wrapper}>
                    <div className={styles.loader} />
                </div>
            )}
            <div className="container">
                <Toolbar
                    className={clsx(toolbarClasses.root)}
                    style={{ display: "flex", justifyContent: "space-around" }}
                >
                    <SearchBar
                        onChange={val => handleChange(val)}
                        onCancelSearch={() => {
                            setKey("");
                            allProduct = [];
                            setLoading(true);
                            setNextButtonDisable(false);
                            getRows(null, null);
                        }}
                        style={{
                            width: 900
                        }}
                        placeholder="Select Product"
                        value={key}
                        autoFocus
                    ></SearchBar>
                    <SelectProductField className={toolbarClasses.selectField} onFieldUpdated={setProductFilterField} />
                </Toolbar>
                <div className={classes.tableWrapper}>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={"is-small"}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            onClick={event => handleClick(event, row.name)}
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row.barcode}
                                        >
                                            <TableCell align="left">{row.barcode}</TableCell>
                                            <TableCell align="left">{!!(row.uid) ? row.uid : ''}</TableCell>

                                            <TableCell style={{ minWidth: 120 }} align="left">
                                                {row.name}
                                            </TableCell>
                                            <TableCell align="left">{row.size}</TableCell>
                                            <TableCell align="left">{row.color.length ? row.color.join(', ') : ''}</TableCell>

                                            <TableCell align="left">{row.brand}</TableCell>
                                            <TableCell align="left">{row.status}</TableCell>

                                            <TableCell align="left">{row.category}</TableCell>
                                            <TableCell align="center">{row.cycles}</TableCell>
                                            <TableCell align="left">{!!(row.supplier) ? row.supplier : ''}</TableCell>
                                            <TableCell align="left">{!!(row.location) ? row.location : ''}</TableCell>
                                            <TableCell align="left">{!!(row.gender) ? row.gender : ''}</TableCell>
                                            <TableCell align="left">{(!!(row.washingdetergent) && row.washingdetergent.length) ? row.washingdetergent.join(', ') : ''}</TableCell>
                                            <TableCell align="left">{!!(row.buyingprice) ? row.buyingprice : ''}</TableCell>
                                            <TableCell align="left">{!!(row.targetsalesprice) ? row.targetsalesprice : ''}</TableCell>
                                            <TableCell align="left">{!!(row.finalsalesprice) ? row.finalsalesprice : ''}</TableCell>
                                            <TableCell align="left">{(!!(row.finalsalesprice) && !!(row.buyingprice)) ? row.finalsalesprice - row.buyingprice : ''}</TableCell>
                                            <TableCell align="left">{!!(row.sold) ? 'Sold' : 'Not sold'}</TableCell>
                                            <TableCell align="left">{!!(row.platformsold) ? row.platformsold : ''}</TableCell>
                                            <TableCell align="left">{!!(row.yearofproduction) ? row.yearofproduction : null}</TableCell>
                                            <TableCell
                                                style={{
                                                    padding: 0,
                                                    width: 113
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <Link to={`/products/${row.id}`} >
                                                        <div
                                                            aria-label="edit"
                                                            // onClick={() => onEdit(row.id)}
                                                            style={{ height: "30px", width: "30px", borderBottom: "none", marginleft: "7px !important", }} >
                                                            <EditIcon
                                                                style={{ height: "100%", width: "80%", padding: "0px !important", color: "black", }}
                                                            />
                                                        </div>
                                                    </Link>
                                                    <IconButton
                                                        className={classes.button}
                                                      onClick={() => HandleDelete(row.id)}
                                                    >
                                                        <img
                                                            src="/delete.svg"
                                                            style={{ width: '19px' }}
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                    <Link to={`/products/${row.id}?tab=repairs`} >
                                                        <div aria-label="repair"
                                                            style={{ height: "140%", width: "110%", padding: "0px !important", color: "black", }}  >
                                                            <i className="fas  fa-lg fa-splotch"></i>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 33 * emptyRows }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        "aria-label": "previous page"
                    }}
                    nextIconButtonProps={{
                        "aria-label": "next page",
                        "disabled": nextButtonDisable
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
}
